export default "__VITE_ASSET__DOfopBv0__"